import { Modalities } from '@/types/modalities';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface ModalitiesState {
	modalities: Modalities[];
	attributes: any[];
	updateModalities: (modalities: Modalities[]) => void;
	updateAttributes: (attributes: any[]) => void;
}

const persistConfig = {
	name: 'gurupass-modalities',
};

export const useModalitiesStore = create<ModalitiesState>()(
	persist(
		devtools(set => ({
			modalities: [],
			attributes: [],
			updateModalities: (modalities: Modalities[]) => set({ modalities }),
			updateAttributes: (attributes: any[]) => set({ attributes }),
		})),
		persistConfig
	)
);

if (global.window && (global.window as any).Cypress) {
	const initialState = (global.window as any).initialState;
	if (initialState) {
		useModalitiesStore.setState(initialState);
	}
	(window as any).modalitiesStore = useModalitiesStore;
}

export default useModalitiesStore;
